import { CommonModule, NgIf } from '@angular/common'
import { Component, inject, OnInit, TemplateRef, ViewChild } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators
} from '@angular/forms'
import { ActivatedRoute, RouterModule } from '@angular/router'
import { CapitalizePipe } from '../../../pipes/capitalize.pipe'
import { PaginationComponent } from '../../template/pagination/pagination.component'
import { Store } from '@ngrx/store'
import { NgbModal, NgbModalRef, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap'
import { map, Observable, of, Subject, takeUntil } from 'rxjs'
import { AppliedLeave } from '../../../store/applied-leave/applied-leave.state'
import { forkJoin } from 'rxjs'
import {
  selectAppliedLeaves,
  selectTotalCount
} from '../../../store/applied-leave/applied-leave.reducer'
// import { selectTotalCount } from '../../../store/applied-leave/applied-leave.selectors'
import {
  createAppliedLeave,
  createAppliedLeaveFailure,
  createAppliedLeaveSuccess,
  loadAppliedLeaves,
  updateAppliedLeave,
  updateAppliedLeaveFailure,
  updateAppliedLeaveSuccess
} from '../../../store/applied-leave/applied-leave.actions'
import dayjs from 'dayjs'
import {
  NgxDaterangepickerBootstrapDirective,
  NgxDaterangepickerBootstrapComponent
} from 'ngx-daterangepicker-bootstrap'
import { AuthState } from '../../../store/auth/auth.state'
import { selectUser } from '../../../store/auth/auth.selectors'
import { environment } from '../../../../environments/environment'
import { LeavePolicy } from '../../../store/leave-policy/leave-policy.state'
import { LeavePolicyService } from '../../../services/leave-policy.service'
import { NgSelectModule } from '@ng-select/ng-select'
import { Actions, ofType } from '@ngrx/effects'
import { UtilsService } from '../../../services/utils.service'
import { SharedModule } from '../../../shared/shared.module'

export enum LeaveType {
  LEAVEWITHOUTPAY = 'Leave Without Pay',
  CASUAL = 'Casual Leave',
  SICK = 'Sick Leave',
  MATERNITY = 'Maternity Leave',
  PATERNITY = 'Paternity Leave',
  BEREAVEMENT = 'Bereavement Leave', //Taken to attend the funeral or recover from the death of a close relative.
  COMPOFF = 'Compensatory Off',
  MARRIAGE = 'Marriage Leave',
  PL = 'Privilege Leave', //A type of paid leave accrued by employees based on their length of service, often taken for vacations or personal time off.
  RELIGIOUSFESTIVAL = 'Religious Festival Leave', //Leave granted to employees to observe their religious festivals.
  STUDY = 'Study Leave', //A type of leave granted to employees to pursue further education or training.
  SABBATICAL = 'Sabbatical Leave', // A longer period of unpaid leave (often months or a year) for personal development, travel, or other purposes.
  FLOATER = 'Floater Leave' //A "floater leave," also known as a floating holiday or floating day, is a paid day off that employees can use at their own discretion, often outside of the standard public holidays. Unlike fixed holidays, employees choose when they take these days off, allowing for flexibility and the ability to accommodate individual needs or preferences.
}

export enum OffType {
  FULLDAY = 'Full Day',
  HALFDAY = 'Half Day',
  FIRSTHALF = 'First Half',
  SECONDHALF = 'Second Half'
}

export enum StatusType {
  APPROVED = 'Approved',
  CANCELLED = 'Cancelled',
  REJECTED = 'Rejected',
  PENDING = 'Pending'
}

interface DateRange {
  startDate: dayjs.Dayjs
  endDate: dayjs.Dayjs
}

declare var bootstrap: any // Add this if you haven't already
declare var $: any // Declare jQuery

@Component({
  selector: 'app-applied-leaves',
  imports: [
    ReactiveFormsModule,
    NgIf,
    CommonModule,
    RouterModule,
    CapitalizePipe,
    // BlockUnblockComponent,
    FormsModule,
    // DeleteComponent,
    PaginationComponent,
    NgbTooltipModule,
    NgxDaterangepickerBootstrapDirective,
    // NgxDaterangepickerBootstrapComponent,
    // HasPermissionDirective
    // BrowserAnimationsModule,
    NgSelectModule,
    SharedModule
  ],
  templateUrl: './applied-leaves.component.html',
  styleUrl: './applied-leaves.component.scss'
})
export class AppliedLeavesComponent implements OnInit {
  private store = inject(Store) // Inject store using `inject()`
  @ViewChild('addBusinessModals') addBusinessModals!: TemplateRef<any>
  @ViewChild('cancelAppliedLeaveModal') cancelAppliedLeaveModal!: TemplateRef<any>

  private modalRef!: NgbModalRef
  private route = inject(ActivatedRoute)
  currentPage = 1
  pageLimit = 10
  loading$: Observable<boolean> = this.store.select(state => state.appliedLeaves.loading)
  error$: Observable<string | null> = this.store.select(state => state.appliedLeaves.error)
  pageLastRecord = 0
  form!: FormGroup
  // this code is writen by shivam
  appliedLeaves: AppliedLeave[] = []
  // ---ended-----
  appliedLeaves$: Observable<AppliedLeave[]> = this.store.select(selectAppliedLeaves)
  totalCount$!: Observable<number>
  totalCount = 0
  search = ''
  leaveTypeEnum = LeaveType // Make the enum accessible in the template

  offTypeEnum = OffType
  statusEnum = StatusType
  // @ViewChild('dateRangeInputModal', { static: false }) dateRangePicker!: BsDaterangepickerDirective
  dateRange!: DateRange
  dateRangeModal = ''
  leaveType = ''
  leaveTypes = Object.values(LeaveType) // Get an array of the enum values for iteration
  status = ''
  dateRangeforHalfDay: { date: string; halfDayOption: string; selectionType: string }[] = [] // Store date and half-day selection
  toDateInvalid = false
  minToDate: string | null = null // Minimum value for toDate
  fromDateSelected = false
  // Get the current date
  private currentDate = new Date()

  // Set the start date to January 1st of the current year
  private startOfYear = new Date(this.currentDate.getFullYear(), 0, 1)

  // Set the end date to December 31st of the current year
  private endOfYear = new Date(this.currentDate.getFullYear(), 11, 31)

  // Format dates to 'YYYY-MM-DD' format
  fromDateFilter = this.startOfYear.toISOString().split('T')[0] // 'YYYY-MM-DD'
  toDateFilter = this.endOfYear.toISOString().split('T')[0] // 'YYYY-MM-DD'
  leavesResponse: any
  disabledDates: any[] = []
  isHalfDay = true
  user: AuthState['user'] | null = null
  blockUnblockStatus = ''
  EditHoliday: any
  apiEndpoint = environment.apiBaseUrl
  defaultImg = '../../../../assets/img/user.jpg'
  leavePolicies$: Observable<LeavePolicy[]> = of([])
  leavePolicies: any[] = []
  leaveId: string | null = null

  private leavePolicyService = inject(LeavePolicyService)
  public selectedLeave: any = ''
  parsedDateRange: { date: string; halfDayOption: string; selectionType: string }[] = []
  private destroyed$ = new Subject<void>()

  constructor(
    private modalService: NgbModal,
    private fb: FormBuilder,
    private actions$: Actions,
    private utilService: UtilsService
  ) {
    this.appliedLeaves$ = this.store.select(selectAppliedLeaves)
    this.totalCount$ = this.store.select(selectTotalCount).pipe(
      map(totalCount => totalCount || 0) // Default to 0 if totalCount is null
    )

    // Subscribe to totalCount$ safely
    // this.totalCount$.subscribe(count => {
    //   this.totalCount = count // Define this.totalCount in your class
    // })

    this.store
      .select(selectUser)
      .pipe(map(user => (this.user = user)))
      .subscribe()

    if (this.user) {
      this.leavePolicies$ = this.leavePolicyService.assignedPolicyByUserId(this.user.id)
    }
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.leaveId = params['id'] || null
      // eslint-disable-next-line no-console
      console.log('Leave ID from URL:', this.leaveId)
      this.loadAppliedLeaves()
    })

    // this.loadAppliedLeaves()

    this.totalCount$.subscribe(count => {
      this.totalCount = count
      this.updatePageLastRecord()
    })

    // this code is writen by shivam

    this.appliedLeaves$.subscribe(leaves => {
      this.appliedLeaves = leaves || []
    })

    //  ------ended-----
    this.form = this.fb.group({
      userId: [this.user?.id, [Validators.required]], // Example validators
      fromDate: ['', [Validators.required]], // Example validators
      toDate: ['', [Validators.required]],
      reason: [''], // Example validators
      leavePolicyId: ['', Validators.required],
      offType: [''],
      status: ['Pending'],
      statusReason: [''],
      halfDayOption: [''],
      daterange: [''],
      leaveType: [''],
      leavePolicy: ['']
    })

    // Assign to class property here
    if (this.user) {
      this.leavePolicies$ = this.leavePolicyService.assignedPolicyByUserId(this.user.id).pipe(
        map(policies =>
          policies.map((policy: { LeavePolicy: LeavePolicy; currentBalance: number }) => ({
            ...policy
            // disabled: policy.currentBalance === 0
          }))
        )
      )
    }

    // Subscribe and store leavePolicies
    this.leavePolicies$.subscribe(policies => {
      this.leavePolicies = policies
    })

    // Now listen for leavePolicyId changes
    this.form.get('leavePolicy')?.valueChanges.subscribe((selected: any) => {
      // console.log('leavePolicy changed:', selected)

      this.form.patchValue({
        leaveType: selected?.leaveType || '',
        leavePolicyId: selected?.id || ''
      })
    })

    this.actions$
      .pipe(
        ofType(
          createAppliedLeaveSuccess,
          createAppliedLeaveFailure,
          updateAppliedLeaveSuccess,
          updateAppliedLeaveFailure
        ),
        takeUntil(this.destroyed$) // don't forget to clean up
      )
      .subscribe(() => {
        this.form.reset({
          status: 'Pending', // 👈 preserve the default value
          statusReason: '',
          userId: this.user?.id
        })
        this.EditHoliday = ''
        this.dateRangeforHalfDay = []
        this.modalService.dismissAll() // or modalRef.close() if you're using one
        this.form.markAsPristine()
        this.form.markAsUntouched()
        this.loadAppliedLeaves()
      })
  }

  loadAppliedLeaves() {
    const params: any = {}

    if (this.leaveId) {
      params.id = this.leaveId
      this.status = ''
    }

    if (this.leaveType) {
      params.leaveType = this.leaveType
    }
    if (this.status) {
      params.status = this.status
    }
    if (this.dateRange?.startDate && this.dateRange?.endDate) {
      params.fromDate = this.dateRange.startDate.format('YYYY-MM-DD')
      params.toDate = this.dateRange.endDate.format('YYYY-MM-DD')
    }
    if (this.user) {
      params.userId = this.user.id
    }
    this.store.dispatch(
      loadAppliedLeaves({
        // params: null
        params: new URLSearchParams(params).toString(),
        page: this.currentPage,
        limit: this.pageLimit
      })
    )
  }

  onSearch() {
    this.currentPage = 1 // Reset to the first page on search
    const params = this.search ? `designationName=${encodeURIComponent(this.search)}` : null

    this.store.dispatch(
      loadAppliedLeaves({ params, page: this.currentPage, limit: this.pageLimit })
    ) // Dispatch action with filter
  }

  onPageChange(newPage: number): void {
    if (newPage > 0) {
      this.currentPage = newPage
      this.loadAppliedLeaves() // Reload businesses for the new page
      this.updatePageLastRecord()
    }
  }

  private updatePageLastRecord() {
    this.pageLastRecord = Math.min(this.currentPage * this.pageLimit, this.totalCount)
  }

  onPageLimitChange() {
    this.currentPage = 1 // Reset to first page when limit changes
    this.loadAppliedLeaves() // Load employees with new page limit
  }

  openBusinessModal(content: TemplateRef<any>, options: any = {}) {
    this.modalRef = this.modalService.open(content, {
      scrollable: false,
      centered: true,
      size: 'lg',
      ...options
    })

    const minDate = dayjs(this.user?.joiningDate).toDate() // ✅ Disables dates before joining
    $('#dateRangeInputModal')
      .daterangepicker({
        autoUpdateInput: true, // ✅ Allow input field to update automatically
        minDate: minDate,
        locale: {
          format: 'DD/MM/YYYY', // Ensure format is correct
          cancelLabel: 'Clear'
        }
      })
      .on('apply.daterangepicker', (ev: any, picker: any) => {
        const formattedStart = picker.startDate.format('DD/MM/YYYY')
        const formattedEnd = picker.endDate.format('DD/MM/YYYY')

        // ✅ Update input field
        $('#dateRangeInputModal').val(`${formattedStart} - ${formattedEnd}`)
        this.form.get('fromDate')?.setValue(picker.startDate.format('YYYY-MM-DD'))
        this.form.get('toDate')?.setValue(picker.endDate.format('YYYY-MM-DD'))
        this.isHalfDay = true
        this.generateDateRange()
        // ✅ Update Angular form
        // this.onDateChange(picker.startDate, picker.endDate);
      })
  }

  onClose() {
    // if (this.form) {
    //   this.form.reset(); // Reset the form if it is defined
    // }
    // this.modalService.dismissAll();
    // this.currentStep = 1;

    try {
      this.dateRangeforHalfDay = []
      this.parsedDateRange = []

      if (this.form) {
        this.form.reset({
          status: 'Pending', // 👈 preserve the default value
          statusReason: ''
        })
      }
      if (this.modalRef) {
        this.modalRef.close()
      }
      this.modalService.dismissAll()
      this.form.markAsPristine()
      this.form.markAsUntouched()
    } catch (error) {
      console.error('Error closing modal:', error)
    }
  }
  getErrorMessage(controlName: string): string | null {
    const control = this.form.get(controlName)
    // console.log('control name', control)
    if (control && control.touched && control.invalid) {
      if (control.hasError('required')) {
        return 'This field is required'
      }
    }
    return null // No error
  }

  onSubmit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched()
      return
    }
    // this.form.get('dateRangeforHalfDay')?.setValue(JSON.stringify(this.dateRangeforHalfDay))
    const { daterange, offType, halfDayOption, leavePolicy, ...payloadWithoutDaterange } =
      this.form.value // ✅ Remove `daterange`
    const payload = {
      ...payloadWithoutDaterange,
      dateRangeforHalfDay: JSON.stringify(this.dateRangeforHalfDay), // manually assign
      userId: this.user ? this.user.id : ''
    }
    if (!this.EditHoliday) {
      this.store.dispatch(createAppliedLeave({ payload: payload }))
    } else {
      this.store.dispatch(updateAppliedLeave({ id: this.EditHoliday.id, payload: payload }))
    }
    this.modalService.dismissAll() // Close modal
  }

  // this method is add by SHIVAm

  //   onSubmit() {
  //   if (this.form.invalid) {
  //     this.form.markAllAsTouched()
  //     return
  //   }

  //   const { daterange, offType, halfDayOption, leavePolicy, ...payloadWithoutDaterange } =
  //     this.form.value

  //   const payload = {
  //     ...payloadWithoutDaterange,
  //     dateRangeforHalfDay: JSON.stringify(this.dateRangeforHalfDay),
  //     userId: this.user ? this.user.id : ''
  //   }

  //   const fromDate = this.form.value.fromDate
  //   const toDate = this.form.value.toDate

  //   // find overlapping leaves
  //   const overlappingLeaves = (this.appliedLeaves || []).filter((leave: any) => {

  //     if (!leave?.date) return false

  //     const d = new Date(leave.date)
  //     if (isNaN(d.getTime())) return false

  //     const leaveDate = d.toISOString().split('T')[0]

  //     return leaveDate >= fromDate && leaveDate <= toDate && leave.status !== 'Cancelled'
  //   })

  //   // cancel overlapping leaves first
  //   overlappingLeaves.forEach((leave: any) => {
  //     this.store.dispatch(
  //       updateAppliedLeave({
  //         id: leave.id,
  //         payload: { ...leave, status: 'Cancelled' }
  //       })
  //     )
  //   })

  //   // create new leave
  //   if (!this.EditHoliday) {
  //     this.store.dispatch(createAppliedLeave({ payload }))
  //   } else {
  //     this.store.dispatch(updateAppliedLeave({ id: this.EditHoliday.id, payload }))
  //   }

  //   this.modalService.dismissAll()
  // }

  // ---ENDED-

  // onSubmit() {
  //   if (this.form.invalid) {
  //     this.form.markAllAsTouched()
  //     return
  //   }

  //   const { daterange, offType, halfDayOption, leavePolicy, ...payloadWithoutDaterange } =
  //     this.form.value

  //   const payload = {
  //     ...payloadWithoutDaterange,
  //     dateRangeforHalfDay: JSON.stringify(this.dateRangeforHalfDay),
  //     userId: this.user ? this.user.id : ''
  //   }

  //   // ✅ Normalize to YYYY-MM-DD string regardless of what format form gives us
  //   const newFrom = new Date(this.form.value.fromDate).toISOString().split('T')[0]
  //   const newTo = new Date(this.form.value.toDate).toISOString().split('T')[0]

  //   // console.log('newFrom:', newFrom, 'newTo:', newTo)

  //   // ✅ Use fromDate/toDate on each leave for overlap detection
  //   const overlappingLeaves = (this.appliedLeaves || []).filter((leave: any) => {
  //     if (!leave?.fromDate || !leave?.toDate) return false

  //     const leaveFrom = new Date(leave.fromDate).toISOString().split('T')[0]
  //     const leaveTo = new Date(leave.toDate).toISOString().split('T')[0]

  //     const isOverlapping = leaveFrom <= newTo && leaveTo >= newFrom

  //     return (
  //       isOverlapping &&
  //       leave.status !== 'Cancelled' &&
  //       leave.status !== 'Rejected' &&
  //       leave.id !== this.EditHoliday?.id
  //     )
  //   })

  //   // console.log('Overlapping leaves to cancel:', overlappingLeaves)

  //   // ✅ Send only the fields your backend expects for a cancel update
  //   overlappingLeaves.forEach((leave: any) => {
  //     this.store.dispatch(
  //       updateAppliedLeave({
  //         id: leave.id,
  //         payload: {
  //           userId: leave.userId,
  //           fromDate: leave.fromDate,
  //           toDate: leave.toDate,
  //           leavePolicyId: leave.leavePolicyId,
  //           leaveType: leave.leaveType,
  //           reason: leave.reason || '',
  //           status: 'Cancelled',
  //           statusReason: 'Auto-cancelled: overlapped by a new leave request',
  //           dateRangeforHalfDay: leave.dateRangeforHalfDay || '[]'
  //         }
  //       })
  //     )
  //   })

  //   // ✅ Create or update the new leave
  //   if (!this.EditHoliday) {
  //     this.store.dispatch(createAppliedLeave({ payload }))
  //   } else {
  //     this.store.dispatch(updateAppliedLeave({ id: this.EditHoliday.id, payload }))
  //   }

  //   this.modalService.dismissAll()
  // }
  onHalfDayChange(index: number, option: string) {
    this.dateRangeforHalfDay[index].halfDayOption = option
  }

  // Function to Set Full Day or Half Day
  setDayType(index: number, type: 'FullDay' | 'HalfDay') {
    this.dateRangeforHalfDay[index].selectionType = type
    if (type === 'FullDay') {
      this.dateRangeforHalfDay[index].halfDayOption = '' // Reset half-day option
    }
  }

  generateDateRange() {
    const fromDate = new Date(this.form.get('fromDate')?.value)
    const toDate = new Date(this.form.get('toDate')?.value)

    if (fromDate && toDate && fromDate <= toDate) {
      // Ensure valid date range
      const tempDate = new Date(fromDate)
      this.dateRangeforHalfDay = [] // Reset before updating
      // tempDate.setDate(tempDate.getDate() + 1)
      tempDate.setDate(tempDate.getDate())
      const tempToDate = new Date(toDate)
      // tempToDate.setDate(tempToDate.getDate() + 1)
      tempToDate.setDate(tempToDate.getDate())

      while (tempDate <= tempToDate) {
        this.dateRangeforHalfDay.push({
          date: tempDate.toISOString().split('T')[0],
          selectionType: 'FullDay', // Default to FullDay
          halfDayOption: '' // Default value
        })
        tempDate.setDate(tempDate.getDate() + 1)
        // tempDate.setDate(tempDate.getDate())
      }
    }
  }

  onDateRangeChange(event: any): void {
    const { startDate, endDate } = event

    if (startDate && endDate) {
      const from = startDate.toDate() // 👈 Convert to JS Date object
      const to = endDate.toDate() // 👈 Convert to JS Date object

      this.form.get('fromDate')?.setValue(from)
      this.form.get('toDate')?.setValue(to)
      this.form.get('daterange')?.setValue({ startDate: from, endDate: to }) // 👈 If daterange control is a grouped object

      this.isHalfDay = true
      this.generateDateRange()
    }
  }

  // this code is writen by SHIVAM

  // generateDateRange() {
  //   const fromDate = new Date(this.form.get('fromDate')?.value)
  //   const toDate = new Date(this.form.get('toDate')?.value)

  //   if (fromDate && toDate && fromDate <= toDate) {

  //     const tempDate = new Date(fromDate)
  //     const tempToDate = new Date(toDate)

  //     this.dateRangeforHalfDay = []

  //     const appliedDates = this.appliedLeaves.map((l: any) =>
  //       new Date(l.date).toISOString().split('T')[0]
  //     )

  //     while (tempDate <= tempToDate) {

  //       const formattedDate = tempDate.toISOString().split('T')[0]

  //       // Skip already applied leave
  //       if (!appliedDates.includes(formattedDate)) {
  //         this.dateRangeforHalfDay.push({
  //           date: formattedDate,
  //           selectionType: 'FullDay',
  //           halfDayOption: ''
  //         })
  //       }

  //       tempDate.setDate(tempDate.getDate() + 1)
  //     }
  //   }

  //   const overlappingLeaves = this.appliedLeaves.filter((leave: any) => {
  //     const leaveDate = new Date(leave.date).toISOString().split('T')[0]

  //     return (
  //       leaveDate >= this.form.value.fromDate &&
  //       leaveDate <= this.form.value.toDate
  //     )
  //   })
  //   overlappingLeaves.forEach((leave: any) => {
  //     // this.store.dispatch(cance({ leaveId: leave.id }))
  //   })
  // }

  // generateDateRange() {
  //   const fromDate = new Date(this.form.get('fromDate')?.value)
  //   const toDate = new Date(this.form.get('toDate')?.value)

  //   if (fromDate && toDate && fromDate <= toDate) {
  //     const tempDate = new Date(fromDate)
  //     const tempToDate = new Date(toDate)
  //     this.dateRangeforHalfDay = []

  //     // ✅ Filter out leaves with invalid dates before mapping
  //     const appliedDates = this.appliedLeaves
  //       .filter((l: any) => l?.fromDate && !isNaN(new Date(l.fromDate).getTime()))
  //       .map((l: any) => new Date(l.fromDate).toISOString().split('T')[0])

  //     while (tempDate <= tempToDate) {
  //       const formattedDate = tempDate.toISOString().split('T')[0]
  //       if (!appliedDates.includes(formattedDate)) {
  //         this.dateRangeforHalfDay.push({
  //           date: formattedDate,
  //           selectionType: 'FullDay',
  //           halfDayOption: ''
  //         })
  //       }
  //       tempDate.setDate(tempDate.getDate() + 1)
  //     }
  //   }
  // }
  openBlockUnblock(content: TemplateRef<any>, options: any = {}, status: any) {
    this.blockUnblockStatus = status
    this.EditHoliday = options
    this.form.get('fromDate')?.setValue(options.fromDate)
    this.form.get('toDate')?.setValue(options.toDate)
    this.form.get('reason')?.setValue(options.reason)
    this.form.get('leavePolicyId')?.setValue(options.leavePolicyId)
    this.form.get('leaveType')?.setValue(options.leaveType)
    this.form.get('status')?.setValue('Cancelled')

    this.modalService.open(content, { scrollable: false, centered: true, size: 'sm' })
  }

  getDashboardRoute(): string {
    // return this.user?.role.name === 'Admin' ? eps.dashboardPath : eps.employeeDashboardPath
    return this.utilService.getDashboardRoute()
  }

  getInitials(firstName: string = '', lastName: string = ''): string {
    const firstInitial = firstName?.charAt(0) || ''
    const lastInitial = lastName?.charAt(0) || ''
    return (firstInitial + lastInitial).toUpperCase()
  }

  openOffcanvasLeave(leave: any) {
    this.selectedLeave = leave
    if (this.selectedLeave?.dateRangeforHalfDay) {
      try {
        this.parsedDateRange = JSON.parse(this.selectedLeave.dateRangeforHalfDay)
      } catch (error) {
        console.error('Invalid JSON in dateRangeforHalfDay:', error)
        this.parsedDateRange = []
      }
    }
  }
}
